// Lift AI
import Lift_AI_LOGO from "../Assets/Images/portfolio/lift-ai/Lift-Tracker-Icon.png";
import Lift_AI_1 from "../Assets/Images/portfolio/lift-ai/Lift-AI-1.PNG";
import Lift_AI_2 from "../Assets/Images/portfolio/lift-ai/Lift-AI-2.PNG";
import Lift_AI_3 from "../Assets/Images/portfolio/lift-ai/Lift-AI-3.PNG";

// LMCT+
import LMCT_Logo from "../Assets/Images/portfolio/lmct/LMCT_Logo.png";
import LMCT_Barcode from "../Assets/Images/portfolio/lmct/LMCT_Barcode.png";
import LMCT_Discounts from "../Assets/Images/portfolio/lmct/LMCT_Discounts.png";
import LMCT_Giveaways from "../Assets/Images/portfolio/lmct/LMCT_Giveaways.png";

// Spotify
import Spotify_Logo from "../Assets/Images/portfolio/spotify/Spotify_Logo.png";
import Spotify_Home from "../Assets/Images/portfolio/spotify/Spotify_Home.png";
import Spotify_Artist from "../Assets/Images/portfolio/spotify/Spotify_Artist.png";
import Spotify_MusicPlayer from "../Assets/Images/portfolio/spotify/Spotify_Music-Player.png";

// Airline
import Airline1 from "../Assets/Images/portfolio/airline/Flight1.png";

// Automation
import Automation1 from "../Assets/Images/portfolio/automation/HomeAutomation.png";
import Automation2 from "../Assets/Images/portfolio/automation/ACControl.png";

// Front Runner
import FrontRunner1 from "../Assets/Images/portfolio/frontrunner/Home.png";
import FrontRunner2 from "../Assets/Images/portfolio/frontrunner/Details.png";

// Event
import EventDetails from "../Assets/Images/portfolio/events/EventDetails.png";
import EventHome from "../Assets/Images/portfolio/events/EventHome.png";

export const showcaseData = {
  1: {
    imgUrl: FrontRunner2,
    title: "Text 2",
  },

  2: {
    imgUrl: FrontRunner1,
    title: "Text 4",
  },

  3: {
    imgUrl: LMCT_Giveaways,
    title: "Text 3",
  },

  4: {
    imgUrl: Spotify_Home,
    title: "Text 5",
  },

  5: {
    imgUrl: Spotify_Artist,
    title: "Text 6",
  },
  7: {
    imgUrl: EventHome,
    title: "Text 1",
  },

  8: {
    imgUrl: EventDetails,
    title: "Text 2",
  },
  9: {
    imgUrl: Airline1,
    title: "Text 3",
  },
  10: {
    imgUrl: Lift_AI_1,
    title: "Text 5",
  },

  11: {
    imgUrl: Lift_AI_2,
    title: "Text 6",
  },
  12: {
    imgUrl: Automation1,
    title: "Text 7",
  },
  13: {
    imgUrl: Automation2,
    title: "Text 7",
  },
};

export const trustedData = {
  0: {
    imgUrl:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/2560px-Google_2015_logo.svg.png",
    title: "Google",
  },

  1: {
    imgUrl:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Blizzard_Entertainment_Logo_2015.svg/1200px-Blizzard_Entertainment_Logo_2015.svg.png",
    title: "Blizzard",
  },
  3: {
    imgUrl:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Meta_Platforms_Inc._logo.svg/2560px-Meta_Platforms_Inc._logo.svg.png",
    title: "Meta",
    height: '16px'
  },
};

export const portfolioData = [
  {
    id: "lift-ai",
    title: "Lift AI",
    logo: Lift_AI_LOGO,
    platform: "iOS",
    categories: "Health & Fitness",
    imgUrl: Lift_AI_1,
    images: [Lift_AI_1, Lift_AI_2, Lift_AI_3],
    caseStudy: false,
    download: "https://apps.apple.com/us/app/lift-ai-workout-tracker/id6677016114"
  },
  {
    id: "lmct-case-study",
    title: "LMCT+",
    logo: LMCT_Logo,
    platform: "iOS, Android",
    categories: "Lifestyle",
    imgUrl: LMCT_Giveaways,
    images: [LMCT_Giveaways, LMCT_Discounts, LMCT_Barcode],
    caseStudy: true,
    download: null
  },
  {
    id: "spotify-case-study",
    title: "Spotify",
    logo: Spotify_Logo,
    platform: "iOS, Android",
    categories: "Music",
    imgUrl: Spotify_Home,
    images: [Spotify_Home, Spotify_Artist, Spotify_MusicPlayer],
    caseStudy: true,
    download: null
  },
];
